import type { SVGProps } from "react";
const SvgLocales = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 26 26" {...props}>
    <path
      className="icon-color-4"
      fill="#fff"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.058.5H4C1.705.5.5 1.647.5 3.942v6.994c.039 2.218 1.244 3.506 3.5 3.506h8.058c2.295 0 3.442-1.147 3.442-3.442V3.942C15.5 1.647 14.353.5 12.058.5Z"
    />
    <path
      className="icon-color-4"
      fill="#fff"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22.058 10.5H14c-2.295 0-3.5 1.147-3.5 3.442v6.994c.039 2.218 1.244 3.506 3.5 3.506h8.058c2.295 0 3.442-1.147 3.442-3.442v-7.058c0-2.295-1.147-3.442-3.442-3.442Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 8 7.973 3.5 6.027 8M10 8H6.027M10 8l1 2M6.027 8 5 10"
    />
    <path stroke="currentColor" strokeLinecap="round" d="M15.5 14.5h6M20 14.5c0 1.923-.5 4-4.923 6" />
    <path stroke="currentColor" strokeLinecap="round" d="M21 20.5c-2-1-3.5-2.5-4-3.5M18.5 14.154V13.5" />
  </svg>
);
export default SvgLocales;
